import React from "react";

import { withApollo } from "../lib/apollo3";
import { SearchPageLayout_v3 } from "RefactorSearchPage/SearchPageLayout_v3";
import { ThemeProvider } from "shared-components/Contexts/Theme/context";
import getConfig from "next/config"
import { decodeHashUrl } from "@Utils/Functions";
import { FiltersContextProvider } from "shared-components/Contexts/Filters/context";
import { ConfigurationsProvider } from "shared-components/Contexts/Configurations/context";
import { AuthModalProvider } from "shared-components/Components/User/AuthModal/web";
import { UserInitialFetch } from "lib/auth";
import { GlobalComponents } from "shared-components/ViewFragments/GlobalComponents/GlobalComponents";
import { UserProvider } from "shared-components/Contexts/User/context";
import AdvertiserProvider from "src/contexts/AdvertiserContext";
import { fetchSearchResults } from "src/services/search";
import { resolveSerpSignalsV2 } from "shared-components/GlobalHooks/useSerpSignalsV2";
import { getOnlyValues, sanitizeMapBound } from "shared-components/Components/Filters/Filters.hook";
import RoutesProvider from "src/contexts/RoutesContext";
import { ContactModalProvider } from "shared-components/Contexts/ContactModal/context";

const { APP_THEME, mainDomain, ...rest } = getConfig().publicRuntimeConfig;

// SearchPage Page
const SearchPage = (props) => {

	return (
		<ThemeProvider active={true} APP_THEME={APP_THEME}>
			<ConfigurationsProvider active={true} initialState={props?.ConfigContextInitialState}>
				<RoutesProvider>
				<FiltersContextProvider
					active={true}
					initialState={props?.FiltersContextInitialState}>
					<AdvertiserProvider>
						<UserProvider active={true} initialState={null}>
							<GlobalComponents>
								<ContactModalProvider>
									<AuthModalProvider />
									<UserInitialFetch />
									<SearchPageLayout_v3 fetchResult={props.fetchResult} />
								</ContactModalProvider>
							</GlobalComponents>
						</UserProvider>
					</AdvertiserProvider>
				</FiltersContextProvider>
				</RoutesProvider>
			</ConfigurationsProvider>
		</ThemeProvider>
	);
};


SearchPage.getInitialProps = async function ({ req, query, res, asPath, apolloClient, ...rest }) {
	const q = decodeHashUrl(query.hashed);
	const filters = sanitizeMapBound(getOnlyValues(q.filters));
	const payload = {
		rows: 21,
		params: filters,
		page: filters?.page || 1,
		source: 10,
	};

	const main_domain = mainDomain;
	const rankingV2 = resolveSerpSignalsV2(query);
	const fetchResult = await fetchSearchResults(payload, main_domain, rankingV2);

	return {
		params: q,
		FiltersContextInitialState: q.filters,
		ConfigContextInitialState: q?.configs,
		fetchResult: fetchResult,
	};
};

export default withApollo(
	SearchPage
);



